import { DigitalRevisionMenuItem } from '../interfaces/digital-revision-menu-item';
import { ProxyTypeEnum } from '../interfaces/proxy-type-enum';
import { MenuItemTypeEnum } from '../interfaces/menu-item-type-enum';

export const HomePageMenuItems: DigitalRevisionMenuItem[] = [
  {
    MenuItemType: MenuItemTypeEnum.ExamPracticeQuestions,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Exam Practice Questions',
    ButtonURL: '',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/BAQ43B/BAQ43B_DigitalWorkbook_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Exam Practice Questions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>See how well you understand each section. Mark your answers with our examples.</p>' +
      '\n' +
      '<p>Questions marked: <strong>[[variable1]]</strong></p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'All the questions from your book',
    SwitcherCookieName: 'CgpDigitalRevision',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.QuickQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Maths Skills Quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/BAQ43B/BAQ43B_MathsSkills_v3',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    ButtonURL: '',
    HasData: true,
    HeadingText: 'Maths Skills Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      "<p>Test yourself on the Maths Skills you\'ll need to help with each Paper.</p>\n" +
      '\n' +
      '<p>Questions answered: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Last quiz score: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Extra practice on the tricky Maths bits',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MistakesQuiz,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#F0542C',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Mistakes Quiz',
    ButtonURL: 'mistakes-quiz',
    MixedOnlineTests: [
      {
        MixedOnlineTestUrl: '_revisionhub_opc/BAQ43B/BAQ43B_MathsSkills_Mistakes_v2',
        Proxy: ProxyTypeEnum.CFProxy,
      },
    ],

    HasData: true,
    HeadingText: 'Your Mistakes Quiz',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '' +
      '<p>The quick quiz questions you got wrong are here — have another go and conquer them once and for all!</p>\n' +
      '\n' +
      '<p>Total questions stored: <strong>[[variable1]]</strong></p>\n' +
      '\n' +
      '<p>Total questions answered: <strong>[[variable2]]</strong></p>',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Correct your wrong answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.VideoExplanations,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'Watch solutions',
    MixedOnlineTests: [],
    ButtonURL: 'content-videos',
    HasData: false,
    HeadingText: 'Video Solutions',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      '<p>Worked answer videos with lots of advice to help you scoop up every last mark.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Step-by-step exam answers',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Title: 'Video Solutions',
        Intro:
          "CGP\'s friendly experts are here to walk you through some of the exam-style questions in your book — have a go at the questions first and use these videos if you need a bit of extra help.",
        LeftSections: [
          {
            Header: 'Topic 1a — Cells and Microscopy',
            Subcategories: [
              {
                Name: 'Cells',
                ShortName: 'Cells',
                Link: 'https://www.youtube.com/embed/T1Zi3IGx2xA?rel=0&modestbranding=1',
              },
              {
                Name: 'Microscopy',
                ShortName: 'Microscopy',
                Link: 'https://www.youtube.com/embed/A2R89ff-4Ac?rel=0&modestbranding=1',
              },
              {
                Name: 'Binary Fission',
                ShortName: 'Binary-Fission',
                Link: 'https://www.youtube.com/embed/iVjhNKJeMhk?rel=0&modestbranding=1',
              },
              {
                Name: 'Stem Cells',
                ShortName: 'Stem-Cells',
                Link: 'https://www.youtube.com/embed/URMezmZwE8A?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 1b — Exchanging Substances',
            Subcategories: [
              {
                Name: 'Exchange Surfaces',
                ShortName: 'Exchange-Surfaces',
                Link: 'https://www.youtube.com/embed/7RrnRxQUVfc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2a — Organisation, Enzymes and Circulation',
            Subcategories: [
              {
                Name: 'Investigating Enzymatic Reactions',
                ShortName: 'Investigating-Enzymatic-Reactions',
                Link: 'https://www.youtube.com/embed/dB6JZ0h_dXw?rel=0&modestbranding=1',
              },
              {
                Name: 'Circulatory System — Blood Vessels',
                ShortName: 'Circulatory-System-Blood-Vessels',
                Link: 'https://www.youtube.com/embed/PXsszYx_UHg?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 2b — Disease and Plant Organisation',
            Subcategories: [
              {
                Name: 'Non-Communicable Disease Risk Factors',
                ShortName: 'Non-Communicable Disease Risk Factors',
                Link: 'https://www.youtube.com/embed/0mp4bLP3lwk?rel=0&modestbranding=1',
              },
              {
                Name: 'Transpiration and Translocation',
                ShortName: 'Transpiration-and-Translocation',
                Link: 'https://www.youtube.com/embed/vcSWHRk5ZCM?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 3 — Infection and Response',
            Subcategories: [
              {
                Name: 'The Spread of Disease',
                ShortName: 'The Spread of Disease',
                Link: 'https://www.youtube.com/embed/6-PQcavxZTc?rel=0&modestbranding=1',
              },
              {
                Name: 'Fighting Disease — Drugs',
                ShortName: 'Fighting-Disease-Drugs',
                Link: 'https://www.youtube.com/embed/bxrnwBEw-wY?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 4 — Bioenergetics',
            Subcategories: [
              {
                Name: 'The Rate of Photosynthesis',
                ShortName: 'The-Rate-of-Photosynthesis',
                Link: 'https://www.youtube.com/embed/wgJlBJZx95c?rel=0&modestbranding=1',
              },
              {
                Name: 'Aerobic and Anaerobic Respiration',
                ShortName: 'Aerobic-and-Anaerobic-Respiration',
                Link: 'https://www.youtube.com/embed/mZq4Q5WPe5o?rel=0&modestbranding=1',
              },
            ],
          },
        ],
        RightSections: [
          {
            Header: 'Topic 5a — The Nervous System',
            Subcategories: [
              {
                Name: 'Homeostasis',
                ShortName: 'Homeostasis',
                Link: 'https://www.youtube.com/embed/pKGw_M5zWoM?rel=0&modestbranding=1',
              },
              {
                Name: 'Controlling Body Temperature',
                ShortName: 'Controlling-Body-Temperature',
                Link: 'https://www.youtube.com/embed/Wrtn5Y1von4?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 5b — Hormones',
            Subcategories: [
              {
                Name: 'The Kidneys',
                ShortName: 'The-Kidneys',
                Link: 'https://www.youtube.com/embed/Vdj_X-jBxgw?rel=0&modestbranding=1',
              },
              {
                Name: 'Plant Hormones',
                ShortName: 'Plant-Hormones',
                Link: 'https://www.youtube.com/embed/jKySJ2GO5BY?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6a — DNA and Reproduction',
            Subcategories: [
              {
                Name: 'X and Y Chromosomes',
                ShortName: 'X-and-Y-Chromosomes',
                Link: 'https://www.youtube.com/embed/Vdx0wQpHzMU?rel=0&modestbranding=1',
              },
              {
                Name: 'The Work of Mendel',
                ShortName: 'The-Work-of-Mendel',
                Link: 'https://www.youtube.com/embed/oGneyDxS-qI?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 6b — Variation, Evolution and Classification',
            Subcategories: [
              {
                Name: 'Antibiotic-Resistant Bacteria',
                ShortName: 'Antibiotic-Resistant-Bacteria',
                Link: 'https://www.youtube.com/embed/haTnwhX6Jqc?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7a — Ecology and Cycles',
            Subcategories: [
              {
                Name: 'Abiotic and Biotic Factors',
                ShortName: 'Abiotic-and-Biotic-Factors',
                Link: 'https://www.youtube.com/embed/qZ8loF4n7A0?rel=0&modestbranding=1',
              },
              {
                Name: 'Using Quadrats',
                ShortName: 'Using-Quadrats',
                Link: 'https://www.youtube.com/embed/xv-9hVejgN0?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Topic 7b — Ecosystems, Biodiversity & Food Production',
            Subcategories: [
              {
                Name: 'Pyramids of Biomass',
                ShortName: 'Pyramids-of-Biomass',
                Link: 'https://www.youtube.com/embed/gL4CPae2VBw?rel=0&modestbranding=1',
              },
            ],
          },
          {
            Header: 'Mixed Questions',
            Subcategories: [
              {
                Name: 'Mixed Questions',
                ShortName: 'Mixed-Questions',
                Link: 'https://www.youtube.com/embed/lYFrGSQ8Gl4?rel=0&modestbranding=1',
              },
            ],
          },
        ],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.Extras,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'View Extras',
    MixedOnlineTests: [],

    ButtonURL: 'extras',
    HasData: false,
    HeadingText: 'Extra Useful Bits',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Tips on what to expect in the exams.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Other resources to download',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    ExtrasOrAnswers: {
      HeaderText: 'Extra Useful Bits',
      ContentMain:
        '<p>Take a look at the info below for advice on what to expect in your Biology exams.</p>\n' +
        '\n' +
        '<p><a href="[[cloudfront_url]]/_revisionhub_opc/BAQ43B/PDFs/cgp-gcse-biology-examhelp.pdf" target="_blank">What to Expect in&nbsp;the Exams</a></p>\n',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: '',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.OnlineEdition,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#E04693',
    ButtonCustomClasses: '',
    ButtonText: 'Go to Your Online Products',
    ButtonURL: '[[external_domain]]/bookspacedemo',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Online Edition',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Use your book wherever you are with your Online Edition — yippee!</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Read your eBook here',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.NeedHelp,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '#D50200',
    ButtonCustomClasses: '',
    ButtonText: 'Take a look',
    ButtonURL: '',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'Need some help?',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText: '<p>Take a look at our helpful FAQs if you need some help.</p>\n',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Check out our video and FAQs',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      TagLine:
        'We’ve put together lots of helpful information on how to get the most out of your Exam Practice Workbook. And if you’ve hit any snags, you’ll find the answers you need here too. ',
      Text:
        '   <h2>Frequently Asked Questions</h2>\n' +
        '\n' +
        '<h5><strong>What is CGP RevisionHub?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Great question! CGP RevisionHub is our online platform where you can find lots of helpful revision, all matched to your GCSE Science Workbooks. Use the quizzes, tests, videos and more to make sure you know your stuff for the exams. &nbsp;  &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I access CGP RevisionHub?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can access CGP RevisionHub on your computer, tablet or phone. Just make sure your device can connect to the internet. Wearing a spinny propellor hat is not required, but it is cool though.  &nbsp;  &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use CGP RevisionHub with my book?</strong>  &nbsp;</h5>\n' +
        '\n' +
        "<p>You'll notice lots of QR codes scattered throughout your book. Just give them a scan and you'll automatically be taken to the relevant quiz, video or other revision thingy-ma-jig!  &nbsp;<strong>  &nbsp;</strong><br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>My CGP RevisionHub isn’t working — what do I do?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>If you can’t find the answer in these FAQs, it\'s time to contact our friendly <a href="#contact"><u>Customer Services team</u></a>.&nbsp;</p>\n' +
        '\n' +
        '<p>You could also ask your friendly neighbourhood psychic, but they will charge...  &nbsp;  &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Do I need an internet connection to use CGP RevisionHub?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Yes, you do. But don't cancel your revision retreat to a remote mountain cave just yet — there are also useful bits that you can download as PDFs to access offline. Phew.  &nbsp; &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>If I log in on a different device, will all my progress be saved?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>Yep. Just log in on your computer, tablet or phone, and all your progress and stats will be there waiting for you.  &nbsp; &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What’s the difference between the Quick Quizzes and Your Mistakes Quiz?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Quick Quizzes are...well, quick! They're a speedy way to test yourself on all the maths skills you’ll need for the course. There's a quiz covering maths skills for Paper 1 and another for Paper 2.  &nbsp;</p>\n" +
        '\n' +
        "<p>Your Mistakes Quiz tests you on any questions you got wrong in your Quick Quizzes. It's really helpful for targeting those bits you find trickier. &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>How do I use the Online Workbook?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>All the questions from your book are available to answer again online and you can filter them by paper or by type, e.g. Practical Skills. There’s also a QR code on each page of your book that will take you directly to the questions for that page. You’ll mark some of the questions yourself by looking at the answers, and the rest are marked automatically in CGP RevisionHub — wow!<strong> &nbsp;</strong><br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I clear my progress so far in CGP RevisionHub and start again?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        '<p>You can reset your answers in the Online Workbook any time you like! There are no takie-backsies in the quizzes though, so you can’t wipe your results and start again from scratch. But practice makes perfect, and you can take the quizzes as many times as you want to improve your scores. Keep going, we believe in you!  &nbsp;<br>\n' +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Can I share my quiz scores and test results with other people?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>You can't share results directly via CGP RevisionHub, but there are other means… Carrier pigeons and smoke signals are both great options. Or you could just tell them, but where's the fun in that?  &nbsp;  &nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>What happens when I’ve answered all the questions?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Ah, one of life's greatest questions — what next? We'd recommend that you keep practising right up until your exams. You’ve got this.&nbsp;<br>\n" +
        '&nbsp;</p>\n' +
        '\n' +
        '<h5><strong>Will I always have access to CGP RevisionHub?</strong><strong>  &nbsp;</strong></h5>\n' +
        '\n' +
        "<p>Once you activate the code in the front of your book, you'll have access for three years. And they’ll be three whole years of bliss, we promise. <br>\n" +
        '&nbsp;</p>',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        LeftSections: [],
        RightSections: [],
        Title: '',
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      Intro: '',
      ProductTitle: '',
      TrackFilePaths: [],
      IntroTitle: '',
      AdditionalInfo: '',
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: 'GCSE Biology',
      BookType: 'Revision Guide',
      AdditionalText: "(you'll find some excellent jokes along the way)",
    },
  },
  {
    MenuItemType: MenuItemTypeEnum.MoreFromCGP,
    IsFreeSample: false,
    Anchor: '',
    ButtonColour: '',
    ButtonCustomClasses: '',
    ButtonText: 'See more CGP revision',
    ButtonURL: '[[external_domain]]/secondary-books/gcse',
    MixedOnlineTests: [],

    HasData: false,
    HeadingText: 'More from CGP',
    IsButtonDisabled: false,
    IsSwitcher: false,
    MainContentText:
      'There’s plenty more revision where this came from! Take a look at some of our other revision books.',
    OptionAContent: '',
    OptionATags: '',
    OptionBContent: '',
    OptionBTags: '',
    SubheadingText: 'Everything you need for revision!',
    SwitcherCookieName: '',
    SwitcherProductCode: '',
    ExtrasOrAnswers: {
      HeaderText: '',
      ContentMain: '',
      ContentRight: {
        ImageUrl: '',
        AltText: '',
      },
    },
    HowToUseThisBook: {
      Text: '',
      VideoLink: '',
    },
    PracticePapers: {
      Content: '',
      Audio: [],
    },
    QAndA: [
      {
        Intro: '',
        Title: '',
        LeftSections: [],
        RightSections: [],
      },
    ],
    AudioVideo: {
      Intro: '',
      Title: '',
      LeftSections: [],
      RightSections: [],
    },
    ListeningAndPoetryTracks: {
      IntroTitle: 'Listening Tracks',
      Intro: '',
      ProductTitle: '',
      AdditionalInfo: '',
      TrackFilePaths: [],
    },
    MenuBar: [
      {
        Text: 'Home',
        ImagePath: '/assets/images/landing/home.png',
        DestinationPage: '',
      },
      {
        Text: 'Your Questions',
        ImagePath: '/assets/images/landing/online-workbook.png',
        DestinationPage: 'Exam-Practice-Questions',
      },
      {
        Text: 'Quizzes',
        ImagePath: '/assets/images/landing/quick-quizzes.png',
        DestinationPage: 'Quick-Quiz',
      },
      {
        Text: 'Videos',
        ImagePath: '/assets/images/landing/video-explanations.png',
        DestinationPage: 'content-videos',
      },
      {
        Text: 'Extra Bits',
        ImagePath: '/assets/images/landing/pdfs.png',
        DestinationPage: 'Extras',
      },
    ],
    HowToRevise: {
      DisplayName: '',
      BookType: '',
      AdditionalText: '',
    },
  },
];
